import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2233c54c&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=less&"
import style1 from "./list.vue?vue&type=style&index=1&id=2233c54c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233c54c",
  null
  
)

export default component.exports